<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">{{ translations('pay_rec.amazon_account_receivable') }}</li>
      </ol>
    </nav>

    <div class="mx-4">
      <span v-for="item in translationsModels" :key="item.key" class="mr-4">
        <input type="radio" :id="item.key" :value="item.key" v-model="menu" class="mr-1">
        <label :for="item.key">{{ item.text }}</label>
      </span>
    </div>
    <hr/>
    <div v-if="menu === 'pay_recv'" class="container-fluid main-container">
      <div class="form-inline mb-2">
        <table class="table-bordered mr-4">
          <thead>
            <tr>
              <th>A. {{ translations('pay_rec.accounts_payable_amount') }}</th>
              <th>B. {{ translations('pay_rec.accounts_receivable_amount') }}</th>
              <th>{{ translations('pay_rec.difference') }}(A-B)</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-right">
              <td style="width:150px;">
                <span v-if="!isAmountLoading">{{ totalAmazon.toLocaleString() }}</span>
                <span v-else><v-progress-circular indeterminate size="18" width="2"></v-progress-circular></span>
              </td>
              <td style="width:150px;">
                <span v-if="!isAmountLoading">{{ totalSale.toLocaleString() }}</span>
                <span v-else><v-progress-circular indeterminate size="18" width="2"></v-progress-circular></span>
              </td>
              <td style="width:150px;">
                <span v-if="!isAmountLoading">{{ (totalAmazon - totalSale).toLocaleString() }}</span>
                <span v-else><v-progress-circular indeterminate size="18" width="2"></v-progress-circular></span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="form-group mr-2 d-flex flex-wrap">
          <span class="mr-1">{{ translations('common.period') }}</span>
          <input v-model="dateFrom" type="date" class="form-control">
          <span class="mr-1 ml-1">〜</span>
          <input v-model="dateTo" type="date" class="form-control">
        </div>
        <div class="form-group">
          <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{ translations('common.search') }}</button>
        </div>
        <div class="form-group mr-3 d-flex flex-wrap" style="margin-left:auto;">
          <v-btn text small style="color:red" @click="deletePayRecv">{{ translations('pay_rec.delete_data') }}</v-btn>
        </div>
      </div>
      <div class="table-scroll mb-2">
        <v-data-table
          class="table table-striped table-no-margin"
          item-key="id"
          :headers="[
            { text: translations('pay_rec.order_number'), value: 'order_no', sortable: false },
            { text: translations('pay_rec.model'), value: 'model', sortable: false },
            { text: translations('pay_rec.quantity'), value: 'quantity', sortable: false },
            { text: translations('pay_rec.total_amount'), value: 'amount', sortable: false },
            { text: translations('pay_rec.order_no_2'), value: 'client_order_number', sortable: false },
            { text: translations('pay_rec.model_no_2'), value: 'sale_model', sortable: false },
            { text: translations('pay_rec.quantity_2'), value: 'sale_quantity', sortable: false },
            { text: translations('pay_rec.total_amount_2'), value: 'sale_amount', sortable: false }
          ]"
          :items="records"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr v-for="(record, i) in items" :key="i" data-href="">
                  <td>{{ record.order_no }}</td>
                  <td>{{ record.model }}</td>
                  <td class="right">{{ record.quantity }}</td>
                  <td class="right">{{ Number(record.amount).toLocaleString() }}</td>
                  <td>{{ record.client_order_number }}</td>
                  <td>{{ record.sale_model }}</td>
                  <td class="right">{{ record.sale_quantity }}</td>
                  <td class="right">{{ record.sale_amount ? Number(record.sale_amount).toLocaleString() : '' }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ translations('pay_rec.no_data_found') }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>

      <div class="form-inline mt-5">
        <table class="table-bordered mr-4">
          <thead>
            <tr>
              <th>A. {{ translations('pay_rec.accounts_payable_amount') }}</th>
              <th>B. {{ translations('pay_rec.accounts_receivable_amount') }}</th>
              <th>{{ translations('pay_rec.difference') }}(A-B)</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-right">
              <td style="width:150px;">
                <span v-if="!isAmountOtherLoading">{{ totalAmazonOther.toLocaleString() }}</span>
                <span v-else><v-progress-circular indeterminate size="18" width="2"></v-progress-circular></span>
              </td>
              <td style="width:150px;">
                <span v-if="!isAmountOtherLoading">{{ totalSaleOther.toLocaleString() }}</span>
                <span v-else><v-progress-circular indeterminate size="18" width="2"></v-progress-circular></span>
              </td>
              <td style="width:150px;">
                <span v-if="!isAmountOtherLoading">{{ (totalAmazonOther - totalSaleOther).toLocaleString() }}</span>
                <span v-else><v-progress-circular indeterminate size="18" width="2"></v-progress-circular></span>
            </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-scroll mt-2">
        <v-data-table
          class="table table-striped table-no-margin"
          item-key="id"
          :headers="[
          { text: translations('pay_rec.order_number'), value: 'order_no', sortable: false },
          { text: translations('pay_rec.model'), value: 'model', sortable: false },
          { text: translations('pay_rec.quantity'), value: 'quantity', sortable: false },
          { text: translations('pay_rec.total_amount'), value: 'amount', sortable: false },
          { text: translations('pay_rec.order_no_2'), value: 'client_order_number', sortable: false },
          { text: translations('pay_rec.model_no_2'), value: 'sale_model', sortable: false },
          { text: translations('pay_rec.quantity_2'), value: 'sale_quantity', sortable: false },
          { text: translations('pay_rec.total_amount_2'), value: 'sale_amount', sortable: false }
          ]"
          :items="otherRecords"
          hide-default-footer
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmptyOther">
                <tr v-for="(record, i) in items" :key="i" data-href="">
                  <td>{{ record.order_no }}</td>
                  <td>{{ record.model }}</td>
                  <td class="right">{{ record.quantity }}</td>
                  <td class="right">{{ Number(record.amount).toLocaleString() }}</td>
                  <td>{{ record.client_order_number }}</td>
                  <td>{{ record.sale_model }}</td>
                  <td class="right">{{ record.sale_quantity }}</td>
                  <td class="right">{{ record.sale_amount ? Number(record.sale_amount).toLocaleString() : '' }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ translations('pay_rec.no_data_found') }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </div>
    <div v-else-if="menu === 'pay_csv'" class="container-fluid main-container">
      <div>
        <div>
          <input type="file" @change="selectPayFile" accept="text/csv">
        </div>
      </div>
      <div class="my-3">
        <v-btn @click="uploadPayRecv">{{ translations('pay_rec.accounts_payable_csv_upload') }}</v-btn>
      </div>
    </div>
    <div v-else-if="menu === 'sku_csv'" class="container-fluid main-container">
      <div>
        <div>
          <input type="file" @change="selectSkuFile" accept="text/csv">
        </div>
      </div>
      <div class="my-3">
        <v-btn @click="uploadSku">SKU {{ translations('pay_rec.csv_upload') }}</v-btn>
      </div>
    </div>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>
<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'AmazonPayRecv',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      MODES: [
        { key: 'pay_recv', text: 'Amazon買掛売掛管理' },
        { key: 'pay_csv', text: 'Amazon買掛CSVインポート' },
        { key: 'sku_csv', text: 'Amazon SKU CSVインポート' }
      ],
      menu: 'pay_recv',
      isInitializing: false,
      isLoading: false,
      isAmountLoading: false,
      isAmountOtherLoading: false,
      apiUrl: process.env.VUE_APP_SHINTARO_API_URL,
      payFile: null,
      skuFile: null,
      totalAmazon: 0,
      totalSale: 0,
      totalAmazonOther: 0,
      totalSaleOther: 0,
      records: [],
      otherRecords: [],
      dateTo: this.$invoiceTools.getCurrentDate(),
      dateFrom: this.$invoiceTools.getCurrentDate(),
      tempDateField: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      }
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    isEmpty () {
      return this.records.length === 0
    },
    isEmptyOther () {
      return this.otherRecords.length === 0
    },
    translationsModels () {
      return this.MODES.map(mode => ({
        ...mode,
        text: this.translations(`pay_rec.${mode.key}`)
      }))
    },
    confirmationChooseFile () {
      return this.translations('pay_rec.message_choose_file')
    }
  },
  watch: {
    page (newVal) {
      if (!this.isInitializing) {
        this.getFilterdList()
      }
    }
  },
  created () {
    let storedFilter = this.$storage.get('AmazonPayRecvParam')

    if (storedFilter) {
      this.dateFrom = storedFilter.start
      this.dateTo = storedFilter.end
    }

    this.initList()
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    selectPayFile (e) {
      e.preventDefault()
      const files = e.target.files
      this.payFile = files[0]
    },
    selectSkuFile (e) {
      e.preventDefault()
      const files = e.target.files
      this.skuFile = files[0]
    },
    uploadPayRecv () {
      // SKUアップロード
      if (!this.payFile) {
        alert(this.confirmationChooseFile)
        return
      }

      const formData = new FormData()
      formData.append('file', this.payFile)
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }

      this.isLoading = true
      this.$http.post(this.apiUrl + '/amazon_pay_recv/pay_recv', formData, config).then(response => {
        const result = response.data
        if (result && result.status === true) {
          this.$toastr.success(result.data)
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(err => {
        this.$toastr.error('エラーが発生しました。' + err.message, 0)
      }).finally(() => {
        this.skuFile = null
        this.isLoading = false
        window.$('input[type="file"]').val('')
      })
    },
    uploadSku () {
      // SKUアップロード
      if (!this.skuFile) {
        alert(this.confirmationChooseFile)
        return
      }

      const formData = new FormData()
      formData.append('file', this.skuFile)
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }

      this.isLoading = true
      this.$http.post(this.apiUrl + '/amazon_pay_recv/sku', formData, config).then(response => {
        const result = response.data
        if (result && result.status === true) {
          this.$toastr.success(result.data)
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(err => {
        this.$toastr.error('エラーが発生しました。' + err.message)
      }).finally(() => {
        this.skuFile = null
        this.isLoading = false
        window.$('input[type="file"]').val('')
      })
    },
    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    initList () {
      if (!this.dateFrom || !this.dateTo) {
        alert('期間を選択してください')
        return
      }

      this.isInitializing = true
      this.isLoading = true
      this.page = 1

      Promise.all([
        this.getFilterdList(),
        this.getOtherList(),
        this.getTotalCount()
      ]).then(() => {
        this.getAmount()
        this.getAmountOther()
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.isInitializing = false
      })
    },

    getFilterdList () {
      // Amazonセラーセントラルの売掛を取得
      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const params = {
        start: this.dateFrom,
        end: this.dateTo,
        offset: offset,
        limit: limit
      }

      this.$storage.set('AmazonPayRecvParam', params)

      this.isLoading = true
      return this.$http.post(this.apiUrl + '/amazon_pay_recv/search', params).then(response => {
        const result = response.data
        if (result && result.status === true) {
          console.log(result)
          this.records = result.list
        } else {
          this.records = []
          this.$toastr.error(result.message, 'エラー')
        }
        return Promise.resolve()
      }).catch(err => {
        this.records = []
        this.$toastr.error('エラーが発生しました。' + err.message)
        return Promise.reject(err)
      }).finally(() => {
        this.isLoading = false
      })
    },

    getOtherList () {
      // Amazonセラーセントラルの売掛を取得
      const params = {
        start: this.dateFrom,
        end: this.dateTo
      }

      this.isLoading = true
      return this.$http.post(this.apiUrl + '/amazon_pay_recv/search_other', params).then(response => {
        const result = response.data
        if (result && result.status === true) {
          console.log(result)
          this.otherRecords = result.list
        } else {
          this.otherRecords = []
          this.$toastr.error(result.message, 'エラー')
        }
        return Promise.resolve()
      }).catch(err => {
        this.otherRecords = []
        this.$toastr.error('エラーが発生しました。' + err.message)
        return Promise.reject(err)
      }).finally(() => {
        this.isLoading = false
      })
    },

    getTotalCount () {
      const params = {
        start: this.dateFrom,
        end: this.dateTo
      }

      this.isLoading = true
      this.totalCount = 0
      return this.$http.post(this.apiUrl + '/amazon_pay_recv/total_count', params).then(response => {
        const result = response.data
        if (result && result.status === true) {
          console.log(result)
          this.totalCount = Number(result.total_count)
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
        return Promise.resolve()
      }).catch(err => {
        this.$toastr.error('エラーが発生しました。' + err.message)
        return Promise.reject(err)
      }).finally(() => {
        this.isLoading = false
      })
    },

    getAmount () {
      const params = {
        start: this.dateFrom,
        end: this.dateTo
      }

      this.isAmountLoading = true
      this.totalAmazon = 0
      this.totalSale = 0
      return this.$http.post(this.apiUrl + '/amazon_pay_recv/amount', params).then(response => {
        const result = response.data
        if (result && result.status === true) {
          console.log(result)
          this.totalAmazon = Number(result.total_amount)
          this.totalSale = Number(result.total_sale_amount)
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(err => {
        this.$toastr.error('エラーが発生しました。' + err.message)
      }).finally(() => {
        this.isAmountLoading = false
      })
    },

    getAmountOther () {
      const params = {
        start: this.dateFrom,
        end: this.dateTo
      }

      this.isAmountOtherLoading = true
      this.totalAmazonOther = 0
      this.totalSaleOther = 0
      return this.$http.post(this.apiUrl + '/amazon_pay_recv/amount_other', params).then(response => {
        const result = response.data
        if (result && result.status === true) {
          console.log(result)
          this.totalAmazonOther = Number(result.total_amount)
          this.totalSaleOther = Number(result.total_sale_amount)
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(err => {
        this.$toastr.error('エラーが発生しました。' + err.message)
      }).finally(() => {
        this.isAmountOtherLoading = false
      })
    },

    deletePayRecv () {
      const result = window.confirm('削除してよろしいですか？')
      if (!result) {
        return
      }

      const params = {
        start: this.dateFrom,
        end: this.dateTo
      }

      this.$http.post(this.apiUrl + '/amazon_pay_recv/delete', params).then(response => {
        const result = response.data
        if (result && result.status === true) {
          this.$toastr.success(result.data)
          this.initList()
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(err => {
        this.$toastr.error('エラーが発生しました。' + err.message)
      }).finally(() => {
      })
    },

    submitSearch () {
      this.initList()
    }
  }
}
</script>
<style>
  input[type="date"]{
    width: 200px;
  }
  table thead tr th, table tr td {
    padding: 7px;
  }
  .detail {
    text-decoration: underline;
    cursor: pointer;
  }
</style>
